import type { MainCarouselType } from '@/types/domains/MainCarouselType';

/**
 * トップFVカルーセルのバナー5枚。支給デザインのバナー素材（PC 1200×668 / SP 750×750）を使う。
 *
 * **支給HTMLは画像の割り当てが1つずれている。** 遷移先と `alt` はラフィーネ-アルファ→エパゴールド600→
 * 青汁→認知のチカラの順だが、当てている画像は epa600→ninchi→raffinee-a→voice で1枚後ろへずれており、
 * さらに `f-banner_aojiru`（青汁）が素材にあるのに未使用のまま残っていた。
 * ここではファイル名と実物のビジュアルが示す本来の対応で組む（→ DESIGN-FEEDBACK.md）。
 */
export const MAIN_CAROUSEL_PC_IMAGES: MainCarouselType[] = [
  {
    type: 'image',
    src: '/image/banner/f-banner_raffinee-a.jpg',
    alt: 'ラフィーネ-アルファ',
    link: '/products/501',
  },
  {
    type: 'image',
    src: '/image/banner/f-banner_epa600.jpg',
    alt: 'ラフィーネエパゴールド',
    link: '/products/559',
  },
  {
    type: 'image',
    src: '/image/banner/f-banner_ninchi.jpg',
    alt: '認知のチカラ',
    link: '/products/210',
  },
  {
    type: 'image',
    src: '/image/banner/f-banner_aojiru.jpg',
    alt: 'いろどり野菜のたんぱく青汁',
    link: '/products/710',
  },
  {
    type: 'image',
    src: '/image/banner/f-banner_voice.jpg',
    alt: 'ご愛用者さまインタビュー',
    link: '/voice',
  },
] as const;

export const MAIN_CAROUSEL_SP_IMAGES: MainCarouselType[] = [
  {
    type: 'image',
    src: '/image/banner/f-banner_raffinee-a_sp.jpg',
    alt: 'ラフィーネ-アルファ',
    link: '/products/501',
  },
  {
    type: 'image',
    src: '/image/banner/f-banner_epa600_sp.jpg',
    alt: 'ラフィーネエパゴールド',
    link: '/products/559',
  },
  {
    type: 'image',
    src: '/image/banner/f-banner_ninchi_sp.jpg',
    alt: '認知のチカラ',
    link: '/products/210',
  },
  {
    type: 'image',
    src: '/image/banner/f-banner_aojiru_sp.jpg',
    alt: 'いろどり野菜のたんぱく青汁',
    link: '/products/710',
  },
  {
    type: 'image',
    src: '/image/banner/f-banner_voice_sp.jpg',
    alt: 'ご愛用者さまインタビュー',
    link: '/voice',
  },
] as const;
